import { useCallback } from 'react';

import { useFullBottomNav } from '@perpay-web/hooks/useFullBottomNavContext';

export function withBottomNav(BottomNavComponent) {
    return (Component) => {
        const BottomNavWrapper = (props) => {
            const bottomNavCb = useCallback(() => <BottomNavComponent />, []);
            useFullBottomNav(bottomNavCb);

            return <Component {...props} />;
        };

        BottomNavWrapper.displayName = 'BottomNavWrapper';

        return BottomNavWrapper;
    };
}
